import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const trackPageView = async () => {
      try {
        // Get session to check if user is authenticated
        const { data: { session } } = await supabase.auth.getSession();
        
        // Track page view with metadata
        await supabase.from('analytics_events').insert({
          event_type: 'page_view',
          user_id: session?.user?.id || null,
          metadata: {
            path: location.pathname,
            search: location.search,
            timestamp: new Date().toISOString(),
            referrer: document.referrer || 'direct',
            userAgent: navigator.userAgent,
          }
        });
      } catch (error) {
        // Silently fail - don't disrupt user experience
        console.error('Page tracking error:', error);
      }
    };

    trackPageView();
  }, [location]);
};
